"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var UtilityConfig={remBase:16},splitUnits=function(e){return{number:parseFloat(e),units:String(e).replace(/^[\d.-]+/,"")}},calculateRem=function(){for(var e="",t=0;t<arguments.length;++t){var r=t<0||arguments.length<=t?void 0:arguments[t];""!==e&&(e+=" ");var i=splitUnits(r);"rem"!==i.units?e+=i.number/UtilityConfig.remBase:e+=i.number,0!=i.number&&(e+="rem")}return e};exports.calculateRem=calculateRem,exports.UtilityConfig=UtilityConfig;



//////////////////
// WEBPACK FOOTER
// ./~/@uie/javascript-style-helpers/dist/index.cjs.min.js
// module id = 32
// module chunks = 0